import { IconButton } from '../../IconButton/index.js'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import { $getSelection, ParagraphNode } from 'lexical'
import { QuoteNode } from '@lexical/rich-text'
import { $setBlocksType } from '@lexical/selection'

export const Quote = ({ nodeType, disabled, size }) => {
  const [editor] = useLexicalComposerContext()

  return (
    <IconButton
      tooltip={nodeType === 'quote' ? 'Remove Quote' : 'Quote'}
      size={size}
      icon="quote-on"
      keyHint="Cmd+Alt+Q"
      keyHintVisualOnly
      toggled={nodeType === 'quote'}
      onClick={() => {
        editor.update(() => {
          const selection = $getSelection()

          $setBlocksType(selection, () =>
            nodeType === 'quote' ? new ParagraphNode() : new QuoteNode(),
          )
        })
      }}
      disabled={disabled}
    />
  )
}
